import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

export interface IOptions {
  name: string;
  id: string;
  isChecked?: boolean;
  icon?: string;
  aria?: string;
}

@Component({
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule],
  selector: 'app-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.scss'],
})
export class CheckboxGroupComponent implements OnChanges {
  // get already selected options from parent
  @Input() selectedOptions: Array<string> = [];

  // Output event for selection change. Reactive form support will be implemented as separate task.
  @Output() selectedOptionsChange = new EventEmitter<Array<string>>();

  // list of options
  @Input() options: Array<IOptions> = [];

  /**
   * checkboxStyle supports square, oval and default checkboxes
   * by default it uses default style
   */
  @Input() checkboxStyle: 'square' | 'oval' | 'default' = 'default';

  /**
   * To update `isChecked` property of options when `selectedOptions` are changed
   *
   * @param changes - SimpleChanges
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes.selectedOptions) {
      this.options.forEach((opts) => {
        const pos = changes.selectedOptions.currentValue.indexOf(opts.id);
        if (pos !== -1) {
          opts.isChecked = true;
        } else {
          opts.isChecked = false;
        }
      });
    }
  }

  updateOptions(opt: IOptions) {
    const pos = this.selectedOptions.indexOf(opt.id);
    if (pos === -1 && opt.isChecked) {
      this.selectedOptions.push(opt.id);
    } else if (!opt.isChecked) {
      // only remove if the option exists
      if (pos > -1) this.selectedOptions.splice(pos, 1);
    }
    this.selectedOptionsChange.emit(this.selectedOptions);
  }
}
